export default "__VITE_ASSET__CwVzMS_s__"